import { type FC } from "react";
import styles from "./Skeleton.module.css";

interface Props {
  width?: string | number;
  height?: string | number;
  variant?: "round" | "square";
  className?: string;
}

const Skeleton: FC<Props> = ({
  height = "16px",
  variant = "round",
  width = "80%",
  className,
}) => {
  return (
    <div
      style={{
        borderRadius: variant === "square" ? "0" : "10px",
        width,
        height,
      }}
      className={`${styles.container} ${styles.waves} ${className}`}
    />
  );
};

export default Skeleton;
